export default "__VITE_ASSET__BG2YF8HJ__"